import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "Pozos Manantial - Cotizador" },
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: { title: "Pozos Manantial" },
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
